import { useCallback, useEffect, useRef, useState } from "react";

const MultiRangeSlider = (
  {
    min,
    max,
    onChange,
    currentMin = min,
    currentMax = max,
    darkBackground = false,
  }: {
    darkBackground: boolean;
    min: number;
    max: number;
    onChange: (props: { min: number; max: number }) => void;
    currentMin: number;
    currentMax: number;
  },
) => {
  const [minVal, setMinVal] = useState(currentMin);
  const [maxVal, setMaxVal] = useState(currentMax);
  const minValRef = useRef<HTMLInputElement>(null);
  const maxValRef = useRef<HTMLInputElement>(null);
  const range = useRef<HTMLDivElement>(null);

  const getPercent = useCallback(
    (value: number) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  useEffect(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value);

      if (range.current) {
        const scale = (maxPercent - minPercent) / 100;
        range.current.style.transform =
          `translateX(${minPercent}%) scaleX(${scale})`;
      }
    }
  }, [minVal, getPercent]);

  useEffect(() => {
    if (minValRef.current) {
      const minPercent = getPercent(+minValRef.current.value);
      const maxPercent = getPercent(maxVal);

      if (range.current) {
        const scale = (maxPercent - minPercent) / 100;
        range.current.style.transform =
          `translateX(${minPercent}%) scaleX(${scale})`;
      }
    }
  }, [maxVal, getPercent]);

  useEffect(() => {
    onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal, onChange]);

  return (
    <div className="container-slideri">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        ref={minValRef}
        onChange={(event) => {
          const value = Math.min(+event.currentTarget.value, maxVal - 1);
          setMinVal(value);
          event.currentTarget.value = value.toString();
        }}
        className={`thumb_ thumb--zindex-3 ${
          (minVal > max - 100) && "thumb--zindex-5"
        }`}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        ref={maxValRef}
        onChange={(event) => {
          const value = Math.max(+event.currentTarget.value, minVal + 1);
          setMaxVal(value);
          event.currentTarget.value = value.toString();
        }}
        className="thumb_ thumb--zindex-4"
      />

      <div className="slider_">
        <div className="slider__track" />
        <div
          ref={range}
          className="slider__range"
          style={{ background: darkBackground ? "#f5f5f5" : "#1e1e1e" }}
        />
        <div
          className="slider__left-value"
          style={{ color: darkBackground ? "#ffffff" : "inherit" }}
        >
          {"R$ " + minVal + ",00"}
        </div>
        <div
          className="slider__right-value"
          style={{ color: darkBackground ? "#ffffff" : "inherit" }}
        >
          {"R$ " + maxVal + ",00"}
        </div>
      </div>
    </div>
  );
};

export default MultiRangeSlider;
